import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HelpersService } from '../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({ standalone: false,
  selector: 'vfa-cp-prefix-select',
  templateUrl: './prefix-select.component.html',
  styleUrls: ['./prefix-select.component.scss'],
})
export class PrefixSelectComponent implements OnInit {
  private prefixes: any;
  public filteredPrefixes: any;
  public prefixFound: any;
  public filter: string = "";
  private countriesList: any;

  @Input() prefix: any;
  @Input() stateCode: any;
  @Input() wait: any;
  @Output() newPrefixEvent: EventEmitter<any> = new EventEmitter;

  @ViewChild("prefixFocus") prefixFocus: any;

  constructor(public helpersService: HelpersService, private translate: TranslateService,) {}

  ngOnInit() {
    this.initComponent();
  }

  private initComponent() {
    this.addLabelInPrefixes();
    if(this.prefix && this.stateCode) {
      this.changePrefix(this.prefix, this.stateCode);
      this.newPrefixEvent.emit(this.prefixFound.prefix);
    }
  }

  private addLabelInPrefixes() {
    this.prefixes = this.helpersService.prefixes;
    this.translate.use(this.translate.currentLang);
    this.helpersService.translationObj.subscribe((res)=> {
      if (res && Object.keys(res).length) {
        this.countriesList = this.helpersService.setListFromLoco(res, this.helpersService.config.REGISTRATION_COUNTRY_PREFIX);
      }
    })
    for(let prefix of this.prefixes) {
      let found = this.countriesList.filter((country: any) => country.value === prefix.stateCode)[0];
      if(found) {
        prefix.label = found.label;
      }
    }
    this.filteredPrefixes = this.prefixes;
  }
  
  public focusOnPrefix() {
    if(this.prefixFocus) {
      this.prefixFocus.nativeElement.focus();
    }
  }

  public selectTriggered(event: any) {
    this.newPrefixEvent.emit(event.value.prefix);
    this.changePrefix(event.value.prefix, event.value.stateCode);
  }

  private changePrefix(prefix: string, stateCode: string) {
    if(prefix) {
      const prefixesArray = this.prefixes.filter((p: any) => p.prefix === prefix);
      if(prefixesArray) {
        if(prefixesArray.length > 1) {
          this.prefixFound = prefixesArray.filter((p: any) => p.stateCode === stateCode)[0];
        } else {
          this.prefixFound = prefixesArray[0];
        }
      }
    } else if(stateCode) {
      const prefixesArray = this.prefixes.filter((p: any) => p.stateCode === stateCode);
      if(prefixesArray) {
        if(prefixesArray.length > 1) {
          this.prefixFound = prefixesArray.filter((p: any) => p.stateCode === stateCode)[0];
        } else {
          this.prefixFound = prefixesArray[0];
        }
      }
    }
  }

  public filterPrefixes() {
    if(!this.filter) {
      this.filteredPrefixes = this.prefixes;
    } else {
      this.filteredPrefixes = this.prefixes.filter((p: any) => p.prefix.includes(this.filter.toLowerCase()) || p.label.toLowerCase().includes(this.filter.toLowerCase()));
      if(!this.filteredPrefixes.length) {
        this.filteredPrefixes = this.prefixes;
      }
    }
  }
}
